// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const frillish: PokeData = {
  "id": 592,
  "name": "frillish",
  "height": 12,
  "weight": 330,
  "base_experience": 67,
  "types": [
    PokeType.WATER,
    PokeType.GHOST
  ],
  "api_moves": [
    "poison-sting",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "absorb",
    "night-shade",
    "recover",
    "bubble",
    "destiny-bond",
    "rain-dance",
    "shadow-ball",
    "whirlpool",
    "water-spout",
    "water-sport",
    "water-pulse",
    "brine",
    "wring-out",
    "ominous-wind",
    "hex"
  ],
  "moves": [
    "hydro-pump",
    "bubble-beam",
    "night-shade",
    "bubble",
    "rain-dance",
    "shadow-ball",
    "whirlpool",
    "water-spout",
    "brine",
    "shadow-dagger",
    "spectral-snatch",
    "liquidation",
    "confuse-ray"
  ],
  "evolution_chain": {
    "id": 301,
    "item": null,
    "species": [
      {
        "name": "frillish",
        "order": 593,
        "types": [
          PokeType.WATER,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "jellicent",
        "order": 594,
        "types": [
          PokeType.WATER,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 592,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 61.25,
    "speed": 40,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
